import { c as _c } from "react/compiler-runtime";
import { NavLink, useLocation } from 'react-router-dom';
import { Badge } from '@/components/ui/badge';
import { usePianoProfileState } from '@/hooks/store/use-piano-profile-store';
import { useTranslation } from '@/hooks/use-translation';
import { cn } from '@/lib/utils';
export interface SidebarPianoCardProps {
  label: string;
}

/**
 * The instrument being worked on, at the top of the sidebar: its name in
 * serif, the demo badge, and the serial number in mono.
 */
export const SidebarPianoCard = t0 => {
  const $ = _c(30);
  const {
    label
  } = t0;
  const {
    t
  } = useTranslation();
  const {
    pathname
  } = useLocation();
  const {
    brand,
    isDemoProfile,
    model,
    serialNumber
  } = usePianoProfileState();
  const isActive = pathname === "/piano";
  let t1;
  if ($[0] !== serialNumber || $[1] !== t) {
    t1 = serialNumber ? t("S/N {{serialNumber}}", {
      ns: "navigation",
      serialNumber
    }) : null;
    $[0] = serialNumber;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const specification = t1;
  const t2 = isActive ? "border-2 border-ptl-brass bg-ptl-brass-soft p-[13px]" : "border border-ptl-rule-strong bg-card p-3.5";
  let t3;
  if ($[3] !== t2) {
    t3 = cn("flex flex-col gap-1 rounded-md text-foreground", t2);
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== label) {
    t4 = <span className="ptl-label">{label}</span>;
    $[5] = label;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== isDemoProfile || $[8] !== t) {
    t5 = isDemoProfile ? <Badge variant="mono">{t("Demo", {
        ns: "navigation"
      })}</Badge> : null;
    $[7] = isDemoProfile;
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <span className="flex items-center justify-between gap-2">{t4}{t5}</span>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== brand || $[14] !== model) {
    t7 = [brand, model].filter(Boolean).join(" ") || undefined;
    $[13] = brand;
    $[14] = model;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== brand || $[17] !== label || $[18] !== model) {
    t8 = brand || model ? <>{brand}{brand && model ? " " : null}{model ? <em className="italic">{model}</em> : null}</> : label;
    $[16] = brand;
    $[17] = label;
    $[18] = model;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t7 || $[21] !== t8) {
    t9 = <span title={t7} className="line-clamp-2 font-serif text-[22px] leading-[1.15] font-medium break-words short:text-[19px]">{t8}</span>;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== specification) {
    t10 = specification ? <span className="font-mono text-[11px] text-muted-foreground">{specification}</span> : null;
    $[23] = specification;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t3 || $[27] !== t6 || $[28] !== t9) {
    t11 = <NavLink to="/piano" className={t3}>{t6}{t9}{t10}</NavLink>;
    $[25] = t10;
    $[26] = t3;
    $[27] = t6;
    $[28] = t9;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  return t11;
};